import React from 'react';
import { InstagramIcon, YoutubeIcon } from 'lucide-react';
interface FooterProps {
  youtubeUrl: string;
  instagramUrl: string;
}
export function Footer({
  youtubeUrl,
  instagramUrl
}: FooterProps) {
  return <footer className="w-full bg-noche text-hueso" data-id="element-83" data-mp="32onl753ftsa0">
      <div className="mx-auto flex w-full max-w-lectura flex-col gap-6 px-6 py-12 sm:flex-row sm:items-center sm:justify-between" data-id="element-84" data-mp="32m1aiwl92wnk">
        <div data-id="element-85" data-mp="3ueim7z0nr6ei">
          <p className="font-serif text-xl text-dorado" data-id="element-86" data-mp="3ug3e1gvl8b8o">Sube de Nivel</p>
          <p className="mt-1 font-sans text-sm text-hueso/55" data-id="element-87" data-mp="38h3r5ed5aiu">
            Coaching de relaciones · PNL y niveles de consciencia
          </p>
        </div>

        <nav aria-label="Redes sociales" className="flex items-center gap-3" data-id="element-88" data-mp="3le2katzkc7br">
          <a href={youtubeUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-sm border border-hueso/20 px-4 py-2 font-sans text-sm text-hueso/85 transition-colors duration-150 ease-out hover:border-dorado hover:text-dorado focus:outline-none focus-visible:ring-2 focus-visible:ring-dorado" data-id="element-89" data-mp="3qc3zh3tvbmhy">
            <YoutubeIcon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="3gbqzykwgyvdj" />
            YouTube
          </a>
          <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-sm border border-hueso/20 px-4 py-2 font-sans text-sm text-hueso/85 transition-colors duration-150 ease-out hover:border-dorado hover:text-dorado focus:outline-none focus-visible:ring-2 focus-visible:ring-dorado" data-id="element-91" data-mp="3v8hr66vzp0s2">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-92" data-mp="hrifzooftryu" />
            Instagram
          </a>
        </nav>
      </div>
      <div className="border-t border-hueso/10" data-id="element-93" data-mp="cvtom8mknhdm">
        <p className="mx-auto w-full max-w-lectura px-6 py-5 font-sans text-xs text-hueso/40" data-id="element-94" data-mp="qsqdi4j4qorv">
          © {new Date().getFullYear()} Sube de Nivel. Este test es una herramienta de orientación y
          no sustituye atención psicológica profesional.
        </p>
      </div>
    </footer>;
}